import { mutatorAction } from "satcheljs";
import { type MailboxInfo } from "owa-client-types";
import { getAsyncItemRegistry } from "../selectors/getAsyncItemRegistry";

/**
 * Sets the response snippet of a single async item. No-op if untracked.
 */
export const setAsyncItemSnippetMutator: (mailboxInfo: MailboxInfo, id: string, responseSnippet: string) => void = mutatorAction("setAsyncItemSnippetMutator", (mailboxInfo, id, responseSnippet) => {
    const entry = getAsyncItemRegistry(mailboxInfo)?.entriesById.get(id);
    if (entry) {
        entry.responseSnippet = responseSnippet;
    }
});
